module.exports = __webpack_public_path__ + "img/vertical_3_6_5012.eef5888a.png";